module.exports = __webpack_public_path__ + "static/media/Bottom Receipt.3fa37473.svg";